/**
 * eg-wishlist.js
 * e.g. Wishlist — localStorage実装
 * 依存なし / Riseテーマ既存JSに非依存
 */

(function () {
  'use strict';

  const STORAGE_KEY = 'eg_wishlist_v1';

  /* ================================================
     Storage API
     保存形式: { handle: string }[] 
     handleのみ保存し、商品情報はWISHLISTページ表示時にShopify APIから取得
  ================================================ */

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      console.warn('eg-wishlist: localStorage write failed', e);
    }
  }

  function isInWishlist(handle) {
    return getWishlist().some(function (item) { return item.handle === handle; });
  }

  function addToWishlist(handle) {
    if (isInWishlist(handle)) return;
    var list = getWishlist();
    list.push({ handle: handle });
    saveWishlist(list);
    dispatchChange(handle, true);
  }

  function removeFromWishlist(handle) {
    var list = getWishlist().filter(function (item) { return item.handle !== handle; });
    saveWishlist(list);
    dispatchChange(handle, false);
  }

  function toggleWishlist(handle) {
    if (isInWishlist(handle)) {
      removeFromWishlist(handle);
    } else {
      addToWishlist(handle);
    }
  }

  /* カスタムイベント: 同一ページ内の複数ボタン同期用 */
  function dispatchChange(handle, added) {
    document.dispatchEvent(new CustomEvent('eg:wishlist:change', {
      detail: { handle: handle, added: added }
    }));
  }

  /* ================================================
     Button UI
  ================================================ */

  function updateButton(btn, inWishlist) {
    btn.setAttribute('aria-pressed', inWishlist ? 'true' : 'false');
    btn.setAttribute('aria-label', inWishlist ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function initButton(btn) {
    var handle = btn.dataset.productHandle;
    if (!handle) return;

    /* 初期状態をlocalStorageから復元 */
    updateButton(btn, isInWishlist(handle));

    btn.addEventListener('click', function () {
      toggleWishlist(handle);
    });
  }

  /* 同一ページ内の全ボタンを同期 */
  document.addEventListener('eg:wishlist:change', function (e) {
    var handle = e.detail.handle;
    var added = e.detail.added;
    document.querySelectorAll('[data-wishlist-btn][data-product-handle="' + handle + '"]')
      .forEach(function (btn) { updateButton(btn, added); });
  });

  /* 別タブ同期 (storage event) */
  window.addEventListener('storage', function (e) {
    if (e.key !== STORAGE_KEY) return;
    /* WISHLISTページなら再描画 */
    if (typeof window.egWishlistPageRender === 'function') {
      window.egWishlistPageRender();
    }
    /* PDPのボタン状態更新 */
    document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      var handle = btn.dataset.productHandle;
      if (handle) updateButton(btn, isInWishlist(handle));
    });
  });

  /* ================================================
     初期化
  ================================================ */

  function initAll() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(initButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ================================================
     WISHLIST Page Renderer
     /pages/wishlist で使用
  ================================================ */

  window.EgWishlist = {
    getWishlist: getWishlist,
    isInWishlist: isInWishlist,
    removeFromWishlist: removeFromWishlist,
    initButton: initButton
  };

})();
